module.exports = __webpack_public_path__ + "static/media/vintage12.715980fc.png";